import { useState, useEffect } from 'react';
import { getHotLinePhone } from './api';

interface HotLinePhone {
  phoneNumber: string;
}

const HotLinePhone = (props: HotLinePhone) => {
  const { phoneNumber } = props;
  const [phone, setPhone] = useState<string>('');
  useEffect(() => {
    if (!phoneNumber) return;
    getHotLinePhone({ phone: phoneNumber })
      .then((res: any) => {
        if (res.code === 0) {
          setPhone(res.data || '');
        }
      });
  }, [phoneNumber]);

  return <span>{phone}</span>;
};

export default HotLinePhone;
